import React, {Component} from 'react';
import {dispatch} from 'react-redux';
import {Grid, Row, Col, Jumbotron} from 'react-bootstrap';
import {Modal} from 'react-bootstrap';
import {HashLink as Link} from 'react-router-hash-link';
import Content from './content'
import SignInForm from './sign-in-form'
import {ClipLoader} from 'react-spinners';
import veri_sign from '../logo-verisign.png';

import inituit_logo from '../intuit-logo.png';
import TrustEBrandLogo from "./truste-brand-logo";


class SignIn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            blank:false
        };




    }



    render() {

        if(this.state.blank == true){
            return (<div></div>);
        }

        if (this.state.loading == true) {
            return (

                <div>

                    <Grid>
                        <Jumbotron>
                            <Row>

                                <div style={{marginTop: 200, marginLeft: 475}}>
                                    <ClipLoader
                                        sizeUnit={"px"}
                                        size={50}
                                        color={'#123abc'}
                                        loading={true}
                                    />
                                </div>

                            </Row>
                        </Jumbotron>
                    </Grid>

                    <Modal>
                    </Modal>
                </div>

            );
        }

        return (

            <div>
                <div>

                    <Grid>

                        <Jumbotron className="not-logged-in">
                            <Row>
                                <Col className="divider" sm={8}>
                                    <Content/>
                                </Col>
                                <Col sm={4}>
                                    <SignInForm/>
                                </Col>
                            </Row>
                        </Jumbotron>

                        <Row>
                            <table className="logo-table">
                                <tbody>
                                <td className="left-brand-logo">
                                    <img src={inituit_logo} alt="logo" width="120" height="40"/> <br/>
                                    <Link to="/tnc" target="_blank"><font size="1.9" color="blue">Terms of
                                        Service</font></Link> |<a href="https://quickbooks.intuit.com/r/"
                                                                  target="_blank"><font color="blue" size="1.75">
                                    Privacy</font></a> <br/>
                                    <font color="#00008b" size="1.75"> © 2019 Intuit Inc. All rights
                                        reserved.</font><br/>
                                </td>
                                <td className="right-brand-logo">
                                    <TrustEBrandLogo />
                                    <a href="https://sealinfo.verisign.com/splash?lang=en&dn=tax%2Design%2Eintuit%2Ecom&form%5Ffile=fdf%2Fsplash%2Efdf"
                                       target="_blank"> <img src={veri_sign} alt="logo" width="130" height="60"/></a>
                                </td>
                                </tbody>
                            </table>
                        </Row>
                    </Grid>
                </div>
            </div>

        );
    }
}


export default SignIn;